import React, { useState } from 'react';
import { Button, cn, DropdownMenu, Flex, Icon, Label } from '@zeal/web-ui';
import { useTranslation } from 'react-i18next';
import { useFormatNumber } from '@zeal/zeal-lib';
import { NotificationsList } from './components/NotificationsList';
import useNotificationsList from './components/useNotificationsList';

export default function Notifications() {
	const { t } = useTranslation('common');
	const { formatNumber } = useFormatNumber();
	const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);

	const {
		isNotificationsEmpty,
		isNotificationUnseen,
		unseenNotificationsCount,
		doMarkAllAsRead,
		isMarkAllAsReadDisabled,
	} = useNotificationsList();

	return (
		<DropdownMenu
			onOpenChange={setIsNotificationsOpen}
			open={isNotificationsOpen}
		>
			<DropdownMenu.Trigger>
				<Button
					variant="none"
					rounded="full"
					className={cn('w-12 h-12 p-3 relative', {
						'bg-surface-hovered': isNotificationsOpen,
					})}
					size="lg"
				>
					<Icon iconName="bell" variant="regular" size="lg" />
					{isNotificationUnseen && (
						<div
							className="w-3 h-3 bg-icon-critical rounded-full absolute"
							style={{
								top: '25%',
								right: '25%',
							}}
						/>
					)}
				</Button>
			</DropdownMenu.Trigger>
			<DropdownMenu.Content
				style={{
					width: '400px',
					boxShadow: '0px 0px 10px 2px rgba(0, 0, 0, 0.04)',
					border: '1px solid var(--Border-Subdued, rgba(133, 139, 147, 0.18))',
				}}
				className="rounded-lg shrink-0 bg-white	z-50 p-0 my-2"
			>
				<Flex
					className="py-4 px-5 border-b border-solid border-divider-default"
					align="center"
					justify="between"
				>
					<Flex gap="1" align="center">
						<Label.Big300>{t('notifications')}</Label.Big300>
						{!isNotificationsEmpty && (
							<Label.Thin100 variant="subdued">
								{`(${formatNumber(unseenNotificationsCount)})`}
							</Label.Thin100>
						)}
					</Flex>
					<Button
						disabled={isMarkAllAsReadDisabled}
						variant="none"
						size="none"
						onClick={doMarkAllAsRead}
					>
						<Label.Mid100
							variant={isMarkAllAsReadDisabled ? 'disabled' : 'interactive'}
						>
							{t('mark_all_as_read')}
						</Label.Mid100>
					</Button>
				</Flex>
				<NotificationsList setIsNotificationsOpen={setIsNotificationsOpen} />
			</DropdownMenu.Content>
		</DropdownMenu>
	);
}
